import React from 'react';
import { svgSprite } from '../../../hybrid/wrappers';
import T from '../../../common/components/T';
import Language from '../../../common/decorators/Language';
import { getStylePropsFunc } from '../../../common/utils/styles';

const SearchBlockMob = ({ compStyles, showFilerForm, screenWidth, textsData, closeModal, translates }) => {
    const getStyleProps = (...keys) => getStylePropsFunc(compStyles, ...keys);

    return (
        <Language page='widget' group='gridFilter' translates={translates}>
            <div {...getStyleProps('adminFilterWindowTitleBlock')}>
                {screenWidth && <div {...getStyleProps('adminFilterWindowcloseDecor')} onClick={closeModal} />}
                <div>
                    <p {...getStyleProps('adminFilterWindowTitle')}>
                        {showFilerForm || !screenWidth
                            ? textsData.filterTitleBig || (
                                  <T
                                      group='gridFilter'
                                      textName='filterTitleBig'
                                      defaultStr='Расширенный фильтр поиска'
                                      page='widget'
                                  />
                              )
                            : textsData.filterTitleSmall || (
                                  <T
                                      group='gridFilter'
                                      textName='gridHeader-searchUser'
                                      defaultStr='Поиск пользователя'
                                      page='widget'
                                  />
                              )}
                    </p>
                </div>
                {!screenWidth && (
                    <div {...getStyleProps('adminFilterWindowclose')} onClick={() => closeModal()}>
                        {svgSprite('cross', {
                            ...getStyleProps('adminFilterWindowcloseSvg'),
                            fill: 'var(--greyExtraDarkColor)'
                        })}
                    </div>
                )}
            </div>
        </Language>
    );
};
export default SearchBlockMob;
